export const getArrowUpSuggestion = <T>(current: number, dropdownItems: T[]) =>
  current <= 0 ? dropdownItems.length - 1 : current - 1;

export const getArrowDownSuggestion = <T>(
  current: number,
  dropdownItems: T[]
) => (current === dropdownItems.length - 1 ? 0 : current + 1);
